<template>
  <section>
    <b-alert variant="secondary" show>
      <b-row cols="12" class="mb-1 alert-heading">
        <b-col class="d-flex align-items-center justify-content-between">
          <b-form-checkbox checked="true" @change="hideShowFilter"
            ><b>show filters</b></b-form-checkbox
          >
          <b-input-group style="width: 400px" class="input-group-merge">
            <b-input-group-prepend is-text class="left-br-10">
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              placeholder="Search"
              v-model="search"
              @input="onSearch"
              class="right-br-10"
            />
          </b-input-group>
          <b-button-group size="sm">
            <b-button
              size="sm"
              v-if="$can('create', 'contract')"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="gradient-primary"
              @click="$router.push('/movies/form/new')"
              >New Movie</b-button
            >
            <b-dropdown size="sm" right text="Actions">
              <b-dropdown-form>
                <b-button
                  block
                  size="sm"
                  class="w-100"
                  variant="gradient-success"
                  @click="downloadCsv"
                >
                  <span class="text-nowrap"> Export Movies.csv </span>
                </b-button>
                <b-dropdown-divider></b-dropdown-divider>

                <b-button
                  block
                  size="sm"
                  class="w-100"
                  variant="gradient-success"
                  @click="onSample"
                >
                  <span class="text-nowrap">
                    Movie Data Upload Sample.xlxs
                  </span>
                </b-button>
              </b-dropdown-form>
            </b-dropdown>
            <b-button
              size="sm"
              v-if="$can('create', 'contract')"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="gradient-warning"
              @click="$router.push('/movies-site')"
              >Website</b-button
            >
          </b-button-group>
        </b-col>
      </b-row>
    </b-alert>

    <b-row v-if="filtersHidden">
      <!-- <b-col sm="12" md="12" lg="8">
        <b-input-group class="input-group-merge mb-1">
          <b-input-group-prepend is-text>
            <feather-icon icon="SearchIcon" />
          </b-input-group-prepend>
        </b-input-group>
      </b-col> -->
      <b-col sm="12" md="2" lg="2">
        <v-select
          placeholder="Movie Status"
          label="Movie Status"
          class="mb-1 w-100 borderRadius-10"
          v-model="activeValue"
          :options="activeOptions"
          :clearable="false"
          @input="onFiltersChange"
        />
      </b-col>
      <b-col sm="12" md="3" lg="3">
        <v-select
          placeholder="Sort By"
          label="title"
          class="mb-1 w-100 borderRadius-10"
          :reduce="(c) => c.value"
          :options="sortByOptions"
          :clearable="false"
          @input="onFiltersChange"
          v-model="activeSort"
        />
      </b-col>
      <!-- <b-col sm="6" md="2" lg="2">
            <b-button
              variant="primary"
              class="w-100 mb-1"
              @click="onFiltersChange"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              >Search</b-button
            >
          </b-col> -->
      <b-col sm="6" md="2" lg="2">
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          class="w-100 mb-1 borderRadius-10"
          @click="clearFilters"
          >Reset</b-button
        >
      </b-col>
    </b-row>

    <b-card no-body v-if="$can('read', 'movie')">
      <b-table
        small
        hover
        bordered
        responsive
        primary-key="id"
        empty-text="No records found"
        show-empty
        :items="moviesList"
        :fields="fields"
        @sort-changed="sortChanged"
        @row-clicked="onRowClicked"
      >
        <template #head(sr)="data">
          <b-badge v-if="allMoviesCount" variant="success">{{
            allMoviesCount
          }}</b-badge>
        </template>
        <template #cell(Sr)="data">
          {{
            data.index +
            1 +
            (pagination.currentPage - 1) * pagination.rowsPerPage
          }}
          <div>
            <b-badge v-if="data.item.draft === 1" variant="light-primary"
              >Draft</b-badge
            >
            <b-badge v-if="data.item.archive === 1" variant="light-primary"
              >Archive</b-badge
            >
          </div>
        </template>
        <template #cell(title)="data">
          <span>{{ data.value }}{{ data.item.draft ? "(draft)" : "" }}</span>
        </template>
        <template #cell(website_visible)="data">
          <b-form-checkbox
            switch
            :checked="data.item.website_visible == 1 ? true : false"
            v-b-tooltip.hover.left.v-primary
            title="Show on Website"
            @change="
              ($event) => {
                const newValue = $event ? '1' : '0';
                showModal(
                  'Are you sure you want to change the visibility?',
                  'save'
                ).then((value) => {
                  if (value) {
                    onChangeWebsiteVisible(newValue, data.item.movie_id);
                  } else {
                    data.item.website_visible =
                      data.item.website_visible === 1 ? 1 : 0;
                    ChangeVisibility(data.item.website_visible);
                  }
                });
              }
            "
          />
        </template>
        <template #cell(additionalInfoData)="data">
          <div style="display: flex;justify-content: center;align-items: center;">
                  <feather-icon
                    style="cursor: pointer"
                    icon="InfoIcon"
                    size="23"
                    @mouseenter="handleMovieHoveredSet(data.item.movie_id)"
                    @mouseleave="handleMovieReleased()"
                  />
                </div>
          <div v-if="hoveredMovieId === data.item.movie_id">
          <hover-metadata-component
            :item="data.item"
            :idField="'movie_id'"
            :createdAt="data.item.createdAt"
            :createdBy="data.item.createdBy_user"
            :updatedAt="data.item.updatedAt"
            :updatedBy="data.item.updatedBy_user"
            :isHovered="hoveredMovieId === data.item.movie_id"
            :showAbove="data.index >= itemsInRow - 3? true : false "
          />
        </div>

        </template>

        <template #cell(actions)="data">
          <div class="text-nowrap">
            <feather-icon
              v-if="$can('read', 'movie')"
              icon="EyeIcon"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.left.v-primary
              variant="outline-primary"
              title="View"
              class="mr-1"
              style="cursor: pointer"
              @click.stop="
                () => {
                  $router.push(`/movies/details/${data.item.movie_id}`);
                }
              "
            />

            <feather-icon
              v-if="$can('update', 'movie')"
              icon="EditIcon"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.bottom.v-primary
              variant="outline-primary"
              title="Edit"
              class="mr-1"
              style="cursor: pointer"
              @click="
                () => {
                  $router.push(`/movies/form/${data.item.movie_id}`);
                }
              "
            />
            <!-- <feather-icon
              v-if="data.item.archive == 0 && $can('update', 'movie')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.bottom.v-primary
              variant="outline-primary"
              title="Archive"
              style="cursor: pointer"
              icon="ArchiveIcon"
              @click="
                () => {
                  console.log('Archieve Button clicked')
                  showModal(
                    'Are you sure want to archive this movie?',
                    'delete'
                  ).then((value) => {
                    if (value) archiveMovie(data.item);
                  });
                }
              "
            /> -->

            <feather-icon
              v-if="data.item.archive == 0 && $can('update', 'movie')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.bottom.v-primary
              variant="outline-primary"
              title="Archive"
              style="cursor: pointer"
              icon="ArchiveIcon"
              @click.stop="handleArchieveClicked(data.item, data.item.movie_id)"
            />
            <feather-icon
              v-else-if="data.item.archive == 1 && $can('update', 'movie')"
              icon="ChevronsUpIcon"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.bottom.v-primary
              variant="outline-primary"
              title="Unarchive"
              @click.stop="
                showModal(
                  'Are you sure want to unarchive this movie?',
                  'delete'
                ).then((value) => {
                  if (value) unArchiveMovie(data.item);
                })
              "
            />
          </div>
        </template>
      </b-table>
      <template #footer>
        <div>
          <b-row>
            <b-col
              class="d-flex align-items-center justify-content-center justify-content-sm-center"
            >
              <b-pagination
                v-if="allMoviesCount"
                id="movie-pagination"
                v-model="pagination.currentPage"
                :total-rows="allMoviesCount"
                :per-page="pagination.rowsPerPage"
                @change="onChange"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0 mt-1 mt-sm-0"
                :limit="15"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-card>
  </section>
</template>

<script>
import {
  BInputGroupPrepend,
  BCard,
  BTable,
  BInputGroupAppend,
  BButton,
  BButtonGroup,
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
  BFormGroup,
  BPagination,
  BInputGroup,
  BFormInput,
  VBTooltip,
  BBadge,
  BFormCheckbox,
  BAlert,
  BDropdownForm,
  BDropdownDivider,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import ToastificationContentVue from "@core/components/toastification/ToastificationContent.vue";
import * as MovieServices from "@/apiServices/MovieServices";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import { downloadFromURL } from "@/utils/helpers";
import qs from "qs";
import showModal from "../../components/ModalConfirmation";
import { TokenService } from "@/apiServices/storageService";
import UploadSheets from "@/views/components/UploadSheets.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import HoverMetadataComponent from "@/views/components/HoverMetadataComponent.vue";
import * as XLSX from "xlsx";
export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    FeatherIcon,
    BInputGroupPrepend,
    BCard,
    BTable,
    BInputGroupAppend,
    BButton,
    BButtonGroup,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BFormGroup,
    BPagination,
    BInputGroup,
    BFormInput,
    vSelect,
    VBTooltip,
    BButton,
    UploadSheets,
    BBadge,
    AppCollapseItem,
    AppCollapse,
    BFormCheckbox,
    BAlert,
    BDropdownForm,
    BDropdownDivider,
    HoverMetadataComponent,
  },
  data() {
    return {
      iconHovered: false,
      showModalUpload: false,
      hoveredMovieId:null,
      BASE_URL: process.env.VUE_APP_BASEURL,
      pagination: {
        currentPage: 1,
        totalRows: 1,
        rowsPerPage: 20,
        perPageOptions: [10, 25, 50, 100],
      },
      debouce: null,
      search: "",
      activeValue: "Active Movies",
      activeOptions: [
        "Active Movies",
        "Archived Movies",
        "Draft Movies",
        "All Movies",
      ],
      files: [],
      fields: [
        "Sr",
        {
          key: "title",
          label: "Title",
          // sortable: true,
        },
        {
          key: "international_title",
          label: "International Title",
          // sortable: true,
        },
        {
          key: "unique",
          label: "Unique ID",
          // sortable: true,
        },
        {
          key: "year",
          label: "Year",
          // sortable: true,
        },
        {
          key: "isan_number",
          label: "ISAN",
          // sortable: true,
        },
        {
          key: "website_visible",
          label: "Website",
        },
        {
          key: "actions",
          label: "Actions",
        },
        {
          key: "additionalInfoData",
          label: "LOGS",
        },

      ],
      moviesList: [],
      allMoviesCount: 0,
      filtersHidden: true,
      sortableColumns: {
        title: { sortActive: true, sortOrder: "DESC" },
        unique: { sortActive: false, sortOrder: "ASC" },
        year: { sortActive: false, sortOrder: "ASC" },
        isan_number: { sortActive: false, sortOrder: "ASC" },
      },
      activeSort:null,
      sortByOptions: [
        { title: "Movie Title (A - Z)", value: "title^asc" },
        { title: "Movie Title (Z - A)", value: "title^desc" },
        { title: "International Title (A - Z)", value: "international_title^asc" },
        { title: "International Title (Z - A)", value: "international_title^desc" },
        { title: "Unique Id (1 - 10)", value: "unique^asc" },
        { title: "Unique Id (10 - 1)", value: "unique^desc" },
        { title: "Year (1 - 10)", value: "year^asc" },
        { title: "Year (10 - 1)", value: "year^desc" },
        { title: "ISAN (1 - 10)", value: "isan_number^asc" },
        { title: "ISAN (10 - 1)", value: "isan_number^desc" },
      ],
      itemsInRow: 20,
    };
  },
  methods: {
    ChangeVisibility(val) {
      console.log(val);
      if (val == "1") {
        return true;
      } else {
        return false;
      }
    },
    handleMovieHoveredSet(movieId){
      console.log("Movie Hovered Set", movieId);
      this.hoveredMovieId = movieId;
    },
    handleMovieReleased(movieId){
      console.log("Movie Released", movieId);
      this.hoveredMovieId = null;
    },
    handleArchieveClicked(payload, movieId) {
      console.log(
        " Archive Button clicked for passed movieId and payload",
        movieId,
        payload
      );
      this.$root.$bvModal
        .msgBoxConfirm("Are you sure you want to archive this movie?", {
          title: "Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.archiveMovie(payload, movieId);

            // Delay hiding the modal to avoid early destruction issues
            setTimeout(() => {
              if (this.$root.$bvModal) {
                this.$root.$bvModal.hide("modal-id"); // Ensure modal is hidden properly
              }
            }, 100);
          }
        })
        .catch((err) => console.error(err));
    },
    onSample() {
      let sheetName = "";
      let excelName = "";
      let data = [
        {
          MOVIE_TITLE: "",
          MOVIE_INTERNATIONAL_TITLE: "",
          MOVIE_UNIQUE_ID: "",
          YEAR: "",
          DURATION: "",
          SUISA_NUMBER: "",
        },
      ];

      sheetName = "Movies";
      excelName = "Corsymo_Movie_Import_Sample.xlsx";

      var dataFinal = XLSX.utils.json_to_sheet(data);
      var wb = XLSX.utils.book_new();
      wb["!cols"] = [{ wch: 25 }];
      XLSX.utils.book_append_sheet(wb, dataFinal, sheetName); // sheetAName is name of Worksheet
      XLSX.writeFile(wb, excelName);
    },
    hideShowFilter() {
      this.filtersHidden = !this.filtersHidden;
    },
    onRowClicked(item, index, event) {
      if (this.$can("read", "movie")) {
        this.$router.push(`/movies/form/${item.movie_id}`);
      }
    },
    async onChangeWebsiteVisible(val, movie_id) {
      try {
        // console.log("val : ", val);
        await MovieServices.saveMovieWebsiteVisible({
          movie_id,
          website_visible: val,
        });
      } catch (error) {
        console.error(`Error in onChangeWebsiteVisible: `, error);
      }
    },

    clearFilters() {
      this.search = "";
      this.activeValue = "Active Movies";
      this.activeSort = null
      this.onFiltersChange();
    },

    downloadCsv() {
      try {
        const token = TokenService.getToken();

        if (!token) {
          alert("Error in getting token");
        }

        let urlStr = `${process.env.VUE_APP_BASEURL}/movie/sheet/download?authorization=${token}`;

        downloadFromURL(urlStr, "Movies", "csv");
      } catch (error) {
        console.error(`Error in downloadCSV `, error);
      }
    },

    onFiltersChange() {
      this.pagination.currentPage = 1;
      this.onChange();
    },

    onChange() {
      // this.pagination.currentPage = 1 ;
      this.$nextTick(async () => {
        await this.getMovies();

        let obj = {
          search: this.search,
          activeValue: this.activeValue,
          pagination: this.pagination,
          activeSort:this.activeSort,
        };

        let objStr = JSON.stringify(obj);

        localStorage.setItem("moviesSearchAndPageination", objStr);
      });
    },

    onSearch() {
      if (this.debouce) clearTimeout(this.debouce);
      this.debouce = setTimeout(() => {
        this.onFiltersChange();
      }, 1000);
    },

    async archiveMovie(payload, movieId) {
      try {
        const movie_id = movieId;
        const service_payload = payload;
        console.log("Movie Id recieved in archieveMovie", movie_id);
        console.log(
          "Archieve Button triggered for movie_id and service_payload",
          movie_id,
          service_payload
        );
        const res = await MovieServices.archiveMovie(movie_id, service_payload);
        console.log("archieve movie function triggered");
        if (res.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: res.data.message || "Movie Archived",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.onFiltersChange();
        }
      } catch (err) {
        console.error("Error in movie archive", err);
      }
    },

    async unArchiveMovie(data) {
      try {
        const movie_id = data.movie_id;
        const res = await MovieServices.unArchiveMovie(movie_id);
        if (res.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: res.data.message || "Movie UnArchived",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.onFiltersChange();
        }
      } catch (err) {
        console.log("Error in movie unarchive");
      }
    },

    async getMovies() {
      try {
        let movie_status = {};
        if (this.search) {
          movie_status = {
            archived: false,
          };
        } else if (this.activeValue == "Active Movies") {
          movie_status = {
            archived: false,
            draft: false,
          };
        } else if (this.activeValue === "Archived Movies") {
          movie_status = {
            archived: true,
            // draft: false,
          };
        } else if (this.activeValue === "Draft Movies") {
          movie_status = {
            archived: false,
            draft: true,
          };
        } else if (this.activeValue == "All Movies") {
          // Empty get all
          movie_status = {};
        }

        const payload = {
          search: this.search,
          limit: this.pagination.rowsPerPage,
          page: this.pagination.currentPage,
          sort: this.activeSort,
          ...movie_status,
        };
        const response = await MovieServices.getAllMovie(payload);

        if (response.data.status) {
          this.moviesList = response.data.data.data;
          this.itemsInRow = this.moviesList.length;
          console.log(response.data.data.data, "backendDataMovies");
          this.allMoviesCount = response.data.data.count;
        }
      } catch (err) {
        console.log("Error in getting movies list ", err);
      }
    },

    showModal,

    async downloadExcel() {
      let queryObj = {
        search: this.search,
        sort: this.sortableColumns,
      };

      if (this.activeValue == "Active Movies") {
        queryObj = {
          ...queryObj,
          archived: false,
          draft: false,
        };
      } else if (this.activeValue === "Archived Movies") {
        queryObj = {
          ...queryObj,
          archived: true,
          draft: false,
        };
      } else if (this.activeValue === "Draft Movies") {
        queryObj = {
          ...queryObj,
          archived: false,
          draft: true,
        };
      } else if (this.activeValue == "All Movies") {
        // Empty get all
        // queryObj = { ...queryObj };
      }

      const queryString = qs.stringify(queryObj);

      fetch(this.BASE_URL + `/movie/downloadExcel?${queryString}`, {
        headers: {
          "content-type": "application/Json",
          authorization: localStorage.getItem("access_token"),
        },
      })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);
          downloadFromURL(
            _url,
            this.activeValue === "Archived Movies"
              ? "ArchivedMovies"
              : "Movies",
            "xlsx"
          );
        })
        .catch((err) => {
          console.error(err);
        });
    },

    sortChanged(ctx) {
      this.sortableColumns[ctx.sortBy] = {
        sortActive: true,
        sortOrder: ctx.sortDesc ? "DESC" : "ASC",
      };

      Object.keys(this.sortableColumns).map((key) => {
        if (key !== ctx.sortBy) {
          this.sortableColumns[key].sortActive = false;
        }
      });

      this.onFiltersChange();
    },

    loadMovies() {
      const objStr = localStorage.getItem("moviesSearchAndPageination");
      if (objStr) {
        let obj = JSON.parse(objStr);
        this.search = obj.search;
        this.activeValue = obj.activeValue;
        this.pagination = obj.pagination;
        this.activeSort = obj.activeSort;
      }
      this.getMovies();
    },
    doColumnStyling(label) {
      switch (label) {
        case "UPDATED AT":
          return "updated-at-label";

        case "UPDATED BY":
          return "updated-by-label";

        case "UPDATED BY USER":
          return "updated-by-user";

        default:
          return "updated-by-user";
      }
    },
  },
  beforeMount() {
    setTimeout(() => {
      this.loadMovies();
    });
  },
};
</script>
<style scoped>
@media only screen and (max-width: 300px) {
  .search-list {
    margin-bottom: -10px;
  }
  .updated-at-tabel {
    width: 25%;
  }
  .updated-by-label {
    width: 25%;
  }
  .updated-by-user {
    width: 25%;
  }
  .container-text {
    font-size: 8px;
  }
}
</style>

<style lang="scss">
.borderRadius-10 {
  & .vs__dropdown-toggle {
    border-radius: 10px !important;
  }
  border-radius: 10px !important;
}

.left-br-10 {
  & .input-group-text {
    border-radius: 10px 0 0 10px !important;
  }
  border-radius: 10px 0 0 10px !important;
}

.right-br-10 {
  border-radius: 0 10px 10px 0 !important;
}
</style>